var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 123,
    viewBox: "0 0 125 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#filter0_f_1568_13872)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4334,
    cy: 61.3013,
    rx: 18.4,
    ry: 17.6333,
    fill: "#6EAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4501 61.3013C80.4501 70.813 72.3993 78.5513 62.4334 78.5513C52.4676 78.5513 44.4168 70.813 44.4168 61.3013C44.4168 51.7896 52.4676 44.0513 62.4334 44.0513C72.3993 44.0513 80.4501 51.7896 80.4501 61.3013Z",
    stroke: "black",
    strokeWidth: 0.766667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#filter1_f_1568_13872)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.4334,
    cy: 61.3013,
    rx: 18.4,
    ry: 17.6333,
    fill: "#6EAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4501 61.3013C80.4501 70.813 72.3993 78.5513 62.4334 78.5513C52.4676 78.5513 44.4168 70.813 44.4168 61.3013C44.4168 51.7896 52.4676 44.0513 62.4334 44.0513C72.3993 44.0513 80.4501 51.7896 80.4501 61.3013Z",
    stroke: "black",
    strokeWidth: 0.766667
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.4999 77.974C76.0854 77.974 84.6666 69.3927 84.6666 58.8073C84.6666 48.2218 76.0854 39.6406 65.4999 39.6406C54.9145 39.6406 46.3333 48.2218 46.3333 58.8073C46.3333 69.3927 54.9145 77.974 65.4999 77.974Z",
    fill: "#6EAEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8317 59L66.9376 57.9842V51.4867H67.6276C69.1801 51.4867 70.4451 52.8475 70.4451 54.515C70.4451 55.3008 71.0967 55.9525 71.8826 55.9525C72.6684 55.9525 73.3201 55.3008 73.3201 54.515C73.3201 51.2567 70.7709 48.6117 67.6276 48.6117H66.9376V47.5C66.9376 46.7142 66.2859 46.0625 65.5001 46.0625C64.7142 46.0625 64.0626 46.7142 64.0626 47.5V48.6117H62.8167C59.9801 48.6117 57.6609 51.0075 57.6609 53.94C57.6609 57.3708 59.6542 58.4633 61.1684 59L64.0626 60.0158V66.4942H63.3726C61.8201 66.4942 60.5551 65.1333 60.5551 63.4658C60.5551 62.68 59.9034 62.0283 59.1176 62.0283C58.3317 62.0283 57.6801 62.68 57.6801 63.4658C57.6801 66.7242 60.2292 69.3692 63.3726 69.3692H64.0626V70.5C64.0626 71.2858 64.7142 71.9375 65.5001 71.9375C66.2859 71.9375 66.9376 71.2858 66.9376 70.5V69.3883H68.1834C71.0201 69.3883 73.3392 66.9925 73.3392 64.06C73.3201 60.61 71.3267 59.5175 69.8317 59ZM62.1267 56.2975C61.1492 55.9525 60.5551 55.6267 60.5551 53.9592C60.5551 52.5983 61.5709 51.5058 62.8359 51.5058H64.0817V56.9875L62.1267 56.2975ZM68.1834 66.5133H66.9376V61.0317L68.8734 61.7025C69.8509 62.0475 70.4451 62.3733 70.4451 64.0408C70.4451 65.4017 69.4292 66.5133 68.1834 66.5133Z",
    fill: "#6EAEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1568_13872",
    x: 0.486782,
    y: 0.121304,
    width: 123.893,
    height: 122.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.7733,
    result: "effect1_foregroundBlur_1568_13872"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1568_13872",
    x: 0.486782,
    y: 0.121304,
    width: 123.893,
    height: 122.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.7733,
    result: "effect1_foregroundBlur_1568_13872"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.ad2b4a15381efe59d887e8dfc50723e7.svg";
export { ForwardRef as ReactComponent };